/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.5 13H14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M20 14V7.49991C20 5.01468 17.9853 3 15.5001 3C15.5001 4.10457 14.6047 5 13.5001 5H10.5001C9.39552 5 8.50009 4.10457 8.50009 3C6.01476 3 4 5.01476 4 7.50009V14C4 16.8003 4 18.2004 4.54497 19.27C5.02433 20.2108 5.78924 20.9757 6.73005 21.455C7.79961 22 9.19974 22 12 22C14.8003 22 16.2004 22 17.27 21.455C18.2108 20.9757 18.9757 20.2108 19.455 19.27C20 18.2004 20 16.8003 20 14Z"
				fill="currentColor"
			/>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3M9.5 13H12H14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.24994 2.25C7.70111 1.04698 8.85118 0.25 10.136 0.25H13.864C15.1488 0.25 16.2988 1.04699 16.7499 2.25C18.959 2.25 20.7498 4.04078 20.7498 6.24982V14.75C20.7498 17.5503 20.7498 18.9504 20.2048 20.02C19.7254 20.9608 18.9605 21.7257 18.0197 22.205C16.9501 22.75 15.55 22.75 12.7498 22.75H11.2498C8.44949 22.75 7.04936 22.75 5.9798 22.205C5.03899 21.7257 4.27409 20.9608 3.79472 20.02C3.24976 18.9504 3.24976 17.5503 3.24976 14.75V6.25018C3.24976 4.04094 5.0407 2.25 7.24994 2.25ZM8.74994 3C8.74994 3.69036 9.30958 4.25 9.99994 4.25H13.9999C14.6903 4.25 15.2499 3.69036 15.2499 3C15.2499 2.30964 14.6903 1.75 13.9999 1.75H9.99994C9.30958 1.75 8.74994 2.30964 8.74994 3ZM9.49951 12.25C9.0853 12.25 8.74951 12.5858 8.74951 13C8.74951 13.4142 9.0853 13.75 9.49951 13.75H14.4995C14.9137 13.75 15.2495 13.4142 15.2495 13C15.2495 12.5858 14.9137 12.25 14.4995 12.25H9.49951Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14.0001C20 16.8003 20 18.2004 19.4551 19.2699C18.9757 20.2108 18.2108 20.9757 17.2699 21.4551C16.2004 22 14.8003 22 12.0001 22H11.6562C9.17981 22 7.9416 22 6.97392 21.5711C5.8391 21.0681 4.93196 20.1609 4.42897 19.0261C4.00005 18.0584 4.00007 16.8202 4.00011 14.3438V14.3438L4 14M16 3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3M16 3C16 2.63571 15.9026 2.29417 15.7324 2C15.5568 1.69637 15.3036 1.4432 15 1.26756M8 3V3C5.79086 3 4 4.79086 4 7V9.5V10M8 3C8 1.89543 8.89543 1 10 1H12M9.5 13H14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 3V3C18.2091 3 20 4.79086 20 7V14C20 16.8003 20 18.2004 19.455 19.27C18.9757 20.2108 18.2108 20.9757 17.27 21.455C16.2004 22 14.8003 22 12 22V22C9.19974 22 7.79961 22 6.73005 21.455C5.78924 20.9757 5.02433 20.2108 4.54497 19.27C4 18.2004 4 16.8003 4 14V7C4 4.79086 5.79086 3 8 3V3M16 3V3C16 1.89543 15.1046 1 14 1H10C8.89543 1 8 1.89543 8 3V3M16 3V3C16 4.10457 15.1046 5 14 5H10C8.89543 5 8 4.10457 8 3V3M9.5 13H12H14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.2498 2.25C8.44949 2.25 7.04936 2.25 5.9798 2.79497C5.03899 3.27433 4.27409 4.03924 3.79472 4.98005C3.24976 6.04961 3.24976 7.44974 3.24976 10.25V14.75C3.24976 17.5503 3.24976 18.9504 3.79472 20.02C4.27409 20.9608 5.03899 21.7257 5.9798 22.205C7.04936 22.75 8.44949 22.75 11.2498 22.75H12.7498C15.55 22.75 16.9501 22.75 18.0197 22.205C18.9605 21.7257 19.7254 20.9608 20.2048 20.02C20.7498 18.9504 20.7498 17.5503 20.7498 14.75V10.25C20.7498 7.44974 20.7498 6.04961 20.2048 4.98005C19.7254 4.03924 18.9605 3.27433 18.0197 2.79497C16.9501 2.25 15.55 2.25 12.7498 2.25H11.2498Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 0.25C7.89543 0.25 7 1.14543 7 2.25C7 3.35457 7.89543 4.25 9 4.25H15C16.1046 4.25 17 3.35457 17 2.25C17 1.14543 16.1046 0.25 15 0.25H9ZM9.5 12.25C9.08579 12.25 8.75 12.5858 8.75 13C8.75 13.4142 9.08579 13.75 9.5 13.75H14.5C14.9142 13.75 15.25 13.4142 15.25 13C15.25 12.5858 14.9142 12.25 14.5 12.25H9.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
